const stats = ['Grupos reducidos', 'Corregir tu postura', 'Eliminar un dolor', 'Mejorar tu rendimiento'];

const BeyondIntro = () => {
  return (
    <section className="bg-sand py-20 px-6 md:px-20">
      <div className="max-w-3xl mx-auto">
        <p className="text-xs tracking-[0.35em] uppercase text-terracotta mb-2">Beyond significa «más que»</p>
        <h2 className="text-2xl md:text-4xl font-sans font-light uppercase tracking-wide leading-tight text-ink mb-6">
          No vienes a hacer una clase,
          <br />
          vienes a sentirte bien.
        </h2>
        <p className="text-ink mb-4">
          Durante años, el método pilates ha sido una base fundamental en mi práctica y en el trabajo con mis alumnos. Ha brindado estructura, conciencia
          corporal y bienestar físico. Sin embargo, con el tiempo he sentido la necesidad de explorar una forma de movimiento más intuitiva y orgánica. Que
          sea adaptable a cada cuerpo y estado emocional. El movimiento, como la vida, es dinámico y en constante evolución.
        </p>
        <p className="text-ink">
          Por eso he desarrollado: una fusión que integra los principios del método pilates con otras disciplinas como: la danza, la movilidad funcional,
          ejercicios de capoeira, animal flow, locomoción, algunas acrobacias, inclusive habilidades cognitivas y emocionales. Este cambio permite mayor
          libertad, creatividad y adaptabilidad, ofreciendo una experiencia más completa que se adapta a todas las necesidades físicas. Te invito a ser parte
          de esta nueva etapa, a moverte desde otro lugar, sin restricciones, con curiosidad, explorando con presencia y libertad!
        </p>
        <div className="flex flex-wrap gap-3 mt-6">
          {stats.map((s) => (
            <span
              key={s}
              className="px-5 py-2 rounded-full border border-terracotta text-terracotta text-sm"
            >
              {s}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeyondIntro;
